const createModalStyles = (lightMode: boolean) => ({
  header: {
    padding: "5px 10px 5px 20px",
    background: lightMode
      ? "linear-gradient(0deg, #0c91cf, #199edc)"
      : "linear-gradient(0deg, #181818, rgb(41 41 41))",
    borderBottom: lightMode ? "" : "1px solid #737171",
    borderTopRightRadius: 8,
    borderTopLeftRadius: 8,
    color: "white",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: 55,
    flexShrink: 0
  },
  box: {
    maxWidth: "95vw",
    maxHeight: "90vh",
    position: "fixed" as const,
    top: "50%",
    height: "85vh",
    transform: "translate(0, -50%)",
    backgroundColor: lightMode ? "white" : "#333",
    borderRadius: "8px",
    border: lightMode ? "" : "1px solid #737171",
    width: "95%",
    left: "2.5%",
    display: "flex",
    flexDirection: "column" as const,
    overflow: "hidden",
    minHeight: 0
  },
  confirmationBox: {
    width: "450px",
    maxWidth: "90vw",
    maxHeight: "80vh",
    position: "fixed" as const,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: lightMode ? "white" : "#333",
    borderRadius: "8px",
    border: lightMode ? "" : "1px solid #737171",
    display: "flex",
    flexDirection: "column" as const,
    overflow: "hidden",
    minHeight: "auto"
  },
  button: {
    border: lightMode ? "1px solid #666" : "1px solid #737171",
    borderRadius: 8,
    padding: 10,
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: lightMode ? "white " : "#444",
    color: lightMode ? "black" : "white",
    cursor: "pointer",
  },
}); 

export default createModalStyles;